import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../services/api';

export const detectPaymentRegion = createAsyncThunk(
  'payment/detectRegion',
  async (_, { rejectWithValue }) => {
    try {
      const override = localStorage.getItem('payment_mode_override');
      if (override === 'INR' || override === 'USD') return { mode: override };
      const res = await api.get('/payments/detect-region');
      return res.data; // { mode: 'INR' | 'USD' }
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Region detection failed');
    }
  }
);

export const createCheckoutSession = createAsyncThunk(
  'payment/createCheckoutSession',
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.post('/payments/create-checkout-session');
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Payment failed');
    }
  }
);

export const verifyPayment = createAsyncThunk(
  'payment/verifyPayment',
  async (sessionId, { rejectWithValue }) => {
    try {
      const res = await api.get(`/payments/verify/${sessionId}`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Verification failed');
    }
  }
);

const paymentSlice = createSlice({
  name: 'payment',
  initialState: {
    loading: false,
    verified: false,
    error: null,
    paymentMode: null,
    regionLoading: false,
    regionError: null,
  },
  reducers: {
    clearPaymentError: (state) => { state.error = null; },
  },
  extraReducers: (builder) => {
    // detectPaymentRegion
    builder.addCase(detectPaymentRegion.pending, (state) => {
      state.regionLoading = true;
      state.regionError = null;
    });
    builder.addCase(detectPaymentRegion.fulfilled, (state, action) => {
      state.regionLoading = false;
      state.paymentMode = action.payload.mode;
    });
    builder.addCase(detectPaymentRegion.rejected, (state, action) => {
      state.regionLoading = false;
      state.regionError = action.payload;
    });

    // createCheckoutSession
    builder.addCase(createCheckoutSession.pending, (state) => { state.loading = true; state.error = null; });
    builder.addCase(createCheckoutSession.fulfilled, (state, action) => {
      state.loading = false;
      // Redirect to Stripe will happen in the component
    });
    builder.addCase(createCheckoutSession.rejected, (state, action) => { state.loading = false; state.error = action.payload; });

    // verifyPayment
    builder.addCase(verifyPayment.pending, (state) => { state.loading = true; });
    builder.addCase(verifyPayment.fulfilled, (state, action) => { state.loading = false; state.verified = action.payload.verified; });
    builder.addCase(verifyPayment.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
  },
});

export const { clearPaymentError } = paymentSlice.actions;
export default paymentSlice.reducer;
